import React, { useEffect, useState } from "react";

import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import axios from "../../axios";
import { useNavigate } from "react-router-dom";
import { phoneFormat } from "../../constants/api";
import PhoneInputComponent from "../../Components/PhoneInputComponent";
import useMixpanel from "../../hooks/useMixpanel";
import LocationVerificationModal from "../../Components/LocationVerificationModal";

const ModalMaintenance = ({
  show,
  setShow,
  category,
  room_uuid,
  text,
  theme,
  company_id,
  selectedCategory,
  requiredFields,
}) => {
  const { track } = useMixpanel();
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [files, setFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [errName, setErrName] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errPhone, setErrPhone] = useState("");
  const [phoneWithoutCode, setPhoneWithoutCode] = useState("");
  const [responseLinks, setResponseLinks] = useState([]);
  const [selectedNote, setSelectedNote] = useState();
  const [openOtherNotes, setOpenOtherNotes] = useState(false);
  const newDesign = localStorage.getItem("new_design");
  const [showLocationModal, setShowLocationModal] = useState(false);
  console.log("category", category);

  const { t } = useTranslation();

  const navigate = useNavigate();
  const handelChangImage = async (e) => {
    setLoading(true);
    const formData = new FormData();
    // console.log("imagessssssssssss", e.target.files[0]);
    setFiles([...files, e.target.files[0]]);
    // setImage(e.target.files[0]);
    formData.append("file", e.target.files[0]);
    // console.log("files", files);

    formData.append("source", "maintenance/attachments");

    await axios
      .post(
        `https://servroom.thedigitalhotelier.com/api/v1/general/upload-file`,
        formData
      )
      .then((res) => {
        setResponseLinks((prevLinks) => [...prevLinks, res.data.data]);
        setPreviewUrls([
          ...previewUrls,
          URL.createObjectURL(e.target.files[0]),
        ]);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
      });
    // console.log("imagesimages", responseLinks);
  };
  useEffect(() => {
    setResponseLinks([]);
    setFiles([]);
    setPreviewUrls([]);
    setPhone("");
    setPhoneWithoutCode("");
    setName("");
    setEmail("");
  }, [category]);

  const handleClose = () => {
    setShow(false);
    setResponseLinks([]);
    setFiles([]);
    setPhone("");
    setPhoneWithoutCode("");
    setName("");
    setEmail("");
    setPreviewUrls([]);
  };

  const dataForm = {
    service_id: category,
    name: name,
    email: email,
    phone: phone.phone,
    note: selectedNote ? selectedNote.name : note,
    attachments: Object.values(responseLinks),
  };
  const submitMaintenanceOrder = () => {
    setIsDisabled(true);

    axios
      .post(`/${room_uuid}/maintenance/${company_id}/order`, dataForm)
      .then((res) => {
        if (res.data.status || res.data.success) {
          track.orderSubmitted({
            order_id: res.data.data?.orderId || "",
            order_number: res.data.data?.orderNumber || "",
            service_type: "maintenance",
            order_source: localStorage.getItem("room_type") || "room",
            items_count: 1,
            subtotal: 0,
            tax: 0,
            delivery_fee: 0,
            other_fees: 0,
            total_amount: 0,
            is_external_service: false,
          });

          navigate(`/${room_uuid}/MaintenanceOrderPlaced`, {
            state: {
              metadata: {
                res: res.data.data,
              },
            },
          });

          setResponseLinks([]);
          setFiles([]);
          setPreviewUrls([]);
          setPhone("");
          setName("");
          setEmail("");
        }

        setIsDisabled(false);
      })
      .catch((err) => {
        setIsDisabled(false);
        console.log(err);
      });
  };
  const handelBook = () => {
    let hasError = false;

    if (name === "") {
      setErrName("The name field is required.");
      hasError = true;
    } else {
      setErrName("");
    }

    if (email === "") {
      setErrEmail("The email field is required.");
      hasError = true;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setErrEmail("The email must be a valid email address.");
      hasError = true;
    } else {
      setErrEmail("");
    }

    if (phoneWithoutCode.trim() === "") {
      setErrPhone("The phone field is required.");
      hasError = true;
    } else {
      setErrPhone("");
    }

    if (hasError) {
      return;
    }

    setShowLocationModal(true);
  };
  const handleLocationVerified = () => {
    setShowLocationModal(false);
    submitMaintenanceOrder();
  };
  const removeItem = (index) => {
    console.log("this index", index);
    // Create a new array without the item at the specified index
    const updatedResponseLink = [
      ...responseLinks.slice(0, index),
      ...responseLinks.slice(index + 1),
    ];
    const updatedPreviewUrls = [
      ...previewUrls.slice(0, index),
      ...previewUrls.slice(index + 1),
    ];

    setResponseLinks(updatedResponseLink);
    setPreviewUrls(updatedPreviewUrls);
  };
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        className={`custom-width pt-4 ${theme ? "food-modal" : ""}`}
      >
        <Modal.Body>
          <button
            type="button"
            className="button close-pop"
            onClick={handleClose}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24.054"
              height="24.625"
              viewBox="0 0 24.054 24.625"
            >
              <defs></defs>
              <path
                id="Icon_ionic-ios-close-circle"
                data-name="Icon ionic-ios-close-circle"
                className="cls-50"
                d="M15.4,3.375A12.17,12.17,0,0,0,3.375,15.687,12.17,12.17,0,0,0,15.4,28,12.17,12.17,0,0,0,27.429,15.687,12.17,12.17,0,0,0,15.4,3.375Zm3.047,16.77L15.4,17.025l-3.047,3.12a.913.913,0,0,1-1.307,0,.959.959,0,0,1,0-1.338l3.047-3.12-3.047-3.12a.959.959,0,0,1,0-1.338.913.913,0,0,1,1.307,0L15.4,14.35l3.047-3.12a.913.913,0,0,1,1.307,0,.966.966,0,0,1,0,1.338l-3.047,3.12,3.047,3.12a.966.966,0,0,1,0,1.338A.9.9,0,0,1,18.449,20.145Z"
                transform="translate(-3.375 -3.375)"
              ></path>
            </svg>
          </button>
          <div className="body-container maintenance ">
            {/* <div className="img-pnl">
            <img className="mod_img" src={imageMod} />
          </div> */}
            <h4>{text}</h4>
            <div className="content-pnl">
              <div className="input-pnl">
                <Row>
                  {selectedCategory &&
                    selectedCategory.notes &&
                    selectedCategory.notes.length > 0 && (
                      <div>
                        <p
                          className="mx-3 font-semibold"
                          style={{ color: newDesign === "true" ? "white" : "" }}
                        >
                          {t("select problem")}
                        </p>
                        <div className="  px-3 mb-4 ">
                          {selectedCategory.notes.map((note) => (
                            <div
                              className=" mb-3 "
                              style={{
                                gap: "5px",
                                alignItems: "center",
                                display:
                                  newDesign === "true" ? "flex" : "block",
                                color:
                                  newDesign === "true" ? "white" : "black ",
                              }}
                            >
                              <Form.Check
                                type="radio"
                                // label={note.name}

                                checked={
                                  selectedNote && selectedNote.id === note.id
                                }
                                onClick={() => {
                                  setSelectedNote(note);
                                  setOpenOtherNotes(false);
                                }}
                              />
                              <span>{note.name}</span>
                            </div>
                          ))}
                          <div
                            className="mt-3"
                            style={{
                              // display: "flex",
                              gap: "5px",
                              alignItems: "center",
                              color: newDesign === "true" ? "white" : "black",
                            }}
                          >
                            <Form.Check
                              type="radio"
                              // label={"Other"}
                              checked={openOtherNotes}
                              onClick={() => {
                                setSelectedNote(null);
                                setOpenOtherNotes(true);
                              }}
                            />
                            <span>{t("Other")}</span>
                          </div>
                        </div>
                      </div>
                    )}
                  {(openOtherNotes ||
                    (selectedCategory &&
                      selectedCategory.notes &&
                      selectedCategory.notes.length <= 0)) && (
                    <Col xs="12">
                      <Form.Group className="mb-3 dark-placeholder i-f-small w-100">
                        <Form.Control
                          as="textarea"
                          placeholder={t(`Note (optional)`)}
                          name="note"
                          value={note}
                          onChange={(e) => setNote(e.target.value)}
                          style={{ height: "106px" }}
                        />
                      </Form.Group>
                    </Col>
                  )}
                  <Col xs="12">
                    <Form.Group className="mb-3 dark-placeholder i-f-small w-100">
                      <Form.Control
                        type="text"
                        placeholder={t("Your Name")}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Form.Group>
                    {errName !== "" && (
                      <span className="err_msg">{t(`${errName}`)}</span>
                    )}
                  </Col>
                  <Col xs="12">
                    <Form.Group className="mb-3 dark-placeholder i-f-small w-100">
                      <Form.Control
                        type="email"
                        placeholder={t("Your Email")}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>
                    {errEmail !== "" && (
                      <span className="err_msg">{t(`${errEmail}`)}</span>
                    )}
                  </Col>
                  <Col xs="12">
                    <Form.Group className="mb-3 dark-placeholder i-f-small w-100">
                      <PhoneInputComponent
                        onChange={(phone, country) => {
                          setPhone((prev) => ({
                            ...prev,
                            phone,
                          }));

                          const numberWithoutCode = phone.slice(
                            country?.dialCode?.length || 0
                          );

                          setPhoneWithoutCode(numberWithoutCode);
                        }}
                      />
                    </Form.Group>
                    {errPhone !== "" && (
                      <span className="err_msg">{t(`${errPhone}`)}</span>
                    )}
                  </Col>

                  <Col xs="12">
                    {loading ? (
                      <>
                        <label htmlFor="choseImage" className="chose_img_mani">
                          Loading...
                        </label>
                        <div htmlFor="choseImagem" className="droupzo_">
                          {/* Loading */}
                          <div className="drop_c">
                            {previewUrls.map((url, index) => (
                              <div>
                                <img key={index} src={url} alt="" />
                                <i
                                  class="fas fa-times"
                                  onClick={() => removeItem(index)}
                                ></i>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <label htmlFor="choseImage" className="chose_img_mani">
                          <i class="fas fa-images"></i>{" "}
                          {t("Attach Images") + " " + "(" + t("Optional") + ")"}
                        </label>
                        <div className="droupzo_">
                          <div className="drop_c">
                            {previewUrls.map((url, index) => (
                              <div>
                                <img key={index} src={url} alt="" />
                                <i
                                  class="fas fa-times"
                                  onClick={() => removeItem(index)}
                                ></i>
                              </div>
                            ))}
                          </div>
                        </div>
                        <input
                          type="file"
                          id="choseImage"
                          className="d-none"
                          onChange={handelChangImage}
                        />
                      </>
                    )}
                    {/* <label htmlFor="choseImage" className="droupzo_">
                    {loading ? "Loading" : "Chose Imgee"}
                    <div>
                      {previewUrls.map((url, index) => (
                        <img key={index} src={url} />
                      ))}
                    </div>
                  </label>
                  <input
                    type="file"
                    id="choseImage"
                    className="d-none"
                    onChange={handelChangImage}
                  /> */}
                  </Col>

                  {/* {previewUrls.map((url, index) => (
                  <img key={index} src={url} />
                ))} */}
                  {/* {Object.values(responseLinks).map((item) => {
                  return <p>{item}</p>;
                })} */}
                </Row>
              </div>
              <div className="spacer-40"></div>
              <div className="padd-div text-center mb-2 ">
                <Button
                  className="reg-btn book fw-normal"
                  onClick={handelBook}
                  disabled={isDisabled}
                >
                  {t(`request`)}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <LocationVerificationModal
        show={showLocationModal}
        room_uuid={room_uuid}
        theme={theme}
        onVerified={handleLocationVerified}
      />
    </>
  );
};

export default ModalMaintenance;
